var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10305",
    "data-name": "Group 10305",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    transform: "translate(321 1888)",
    fill: "#fff",
    stroke: "#4a13b2",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_note",
    "data-name": "vuesax/outline/note",
    transform: "translate(-92.866 1650.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note",
    transform: "translate(428 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.733,22.244H5.489C2,22.244,0,20.245,0,16.755V5.489C0,1.849,1.849,0,5.489,0a.873.873,0,0,1,.867.867A1.736,1.736,0,0,0,8.089,2.6h4.044A1.731,1.731,0,0,0,13.866.867.873.873,0,0,1,14.733,0c3.64,0,5.489,1.849,5.489,5.489V16.755C20.222,20.245,18.223,22.244,14.733,22.244Zm-10-20.487c-1.826.15-3,.971-3,3.732V16.755c0,2.565,1.19,3.755,3.755,3.755h9.244c2.565,0,3.755-1.19,3.755-3.755V5.489c0-2.762-1.179-3.571-3-3.732a3.473,3.473,0,0,1-3.351,2.577H8.089a3.435,3.435,0,0,1-2.45-1.017A3.491,3.491,0,0,1,4.738,1.756Z",
    transform: "translate(3.755 4.044)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.511,6.933H3.467A3.472,3.472,0,0,1,0,3.467,3.477,3.477,0,0,1,3.467,0H7.511a3.472,3.472,0,0,1,3.467,3.467A3.477,3.477,0,0,1,7.511,6.933Zm-4.044-5.2a1.733,1.733,0,0,0,0,3.467H7.511a1.733,1.733,0,0,0,0-3.467Z",
    transform: "translate(8.378 1.444)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.489,1.733H.867A.873.873,0,0,1,0,.867.873.873,0,0,1,.867,0H5.489a.873.873,0,0,1,.867.867A.873.873,0,0,1,5.489,1.733Z",
    transform: "translate(8.378 14.155)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M10.111,1.733H.867A.873.873,0,0,1,0,.867.873.873,0,0,1,.867,0h9.244a.873.873,0,0,1,.867.867A.873.873,0,0,1,10.111,1.733Z",
    transform: "translate(8.378 18.777)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H27.732V27.732H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H27.732V27.732H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPChart);
export default __webpack_public_path__ + "static/media/p-chart.ad772d6159eb54583d2dfbcbc4af93af.svg";
export { ForwardRef as ReactComponent };